import DataTable from 'react-data-table-component';
import styles from "./DataTable.module.scss";
import React, { useEffect, useState } from 'react';
import columns from './columnDefsAssessments';
import columnsLabels from './columnDefsAssessmentsLabels';
import columnsInvites from './columnDefsAssessmentInvites';
import { useQuery } from '@apollo/client';
import { ASSESSMENTS, ASSESSMENTS_ROUTES, ASSESSMENTS_INVITES, TAG_SUGGESTIONS } from '../../apollo/queries';
import { Field, Formik } from 'formik';
import { Input } from '../common/Input';

import { AssessmentInviteTableRow, AssessmentTableRow } from './types';
import moment from 'moment/moment';
import { customStyles } from './customStyles';
import { RequestAssessment } from '../RequestAssessment';
import { AssessmentRoute } from '../../apollo/types/AssessmentRoute';
import { Button } from '../common/Button';
import { RemindAssesssment } from '../RemindAssessment';
import { ShareAssessment } from '../ShareAssessment';
import { useLocation } from 'react-router-dom';
import { parseQuery } from '../../utils/urlUtils';
import ReactTags from 'react-tag-autocomplete'
import {Debugger} from "inspector";
import Loader from "../common/Loader";

const initialFormValues = {
    search: "",
};

const TABLE_TYPE_ASSESSMENTS = 'ASSESSMENTS'
const TABLE_TYPE_INVITES = 'INVITES'
const TABLE_TYPE_LABELS = 'LABELS'


// @ts-ignore
const mapDataLabels = (data) => {
    // @ts-ignore
    return data.assessments.map((row) => {
        let parentName = row.organisation.parent ? row.organisation.parent.name : '-';
        if(row.organisation.organisationType === 'ADMIN') {
            parentName = row.organisation.name
        }
        if(row.institute && row.institute.name) {
            parentName = row.institute.name
        }
        let scanType = 'ConsistencyScan'
        if(row.link && row.link.includes('discovery')) {
            scanType = 'DiscoveryScan'
        }
        return {
            id: row.id,
            companyName: row.venture,
            // status: row.status === 'STARTED' ? 'Gestart' : 'Afgerond',
            assessmentDate: row.completionTime !== null
                ? moment(row.completionTime).format('YYYY-MM-DD HH:mm')
                : moment(row.createdAt).format('YYYY-MM-DD HH:mm'),
            sector: row.sector,
            tags: row.tags
        }
    })
}

// @ts-ignore
const mapData = (data) => {
    // @ts-ignore
    return data.assessments.map((row) => {
        let parentName = row.organisation.parent ? row.organisation.parent.name : '-';
        if(row.organisation.organisationType === 'ADMIN') {
            parentName = row.organisation.name
        }
        if(row.institute && row.institute.name) {
            parentName = row.institute.name
        }
        let scanType = 'ConsistencyScan'
        if(row.link && row.link.includes('discovery')) {
            scanType = 'DiscoveryScan'
        }
        return {
            id: row.id,
            link: row.link,
            scanType,
            companyParentName: parentName,
            companyName: row.venture,
            // status: row.status === 'STARTED' ? 'Gestart' : 'Afgerond',
            assessmentDate: row.completionTime !== null
                ? moment(row.completionTime).format('YYYY-MM-DD HH:mm')
                : moment(row.createdAt).format('YYYY-MM-DD HH:mm'),
            contactPerson: row.contact,
            founder: row.founder,
            foundingDate: row.organisation.foundingDate,
            sector: row.sector,
            pdfUrl: row.reviewedPdfUrl ? row.reviewedPdfUrl : row.pdfUrl,
            questionnairePdfUrl: row.reviewedQuestionnairePdfUrl ? row.reviewedQuestionnairePdfUrl : row.questionnairePdfUrl,
            tags: row.tags
        }
    })
}

// @ts-ignore
const mapDataInvites = (data) => {
    console.log(data)
    // @ts-ignore
    return data.assessmentInvites.map((row) => {
        let parentName = row.organisation.parent ? row.organisation.parent.name : '-';
        if(row.organisation.organisationType === 'ADMIN') {
            parentName = row.organisation.name
        }
        return {
            id: row.id,
            companyParentName: parentName,
            companyName: row.venture,
            // status: row.status === 'STARTED' ? 'Gestart' : 'Afgerond',
            founder: row.founder,
            emailAddressFounder: row.emailAddressFounder,
            assessmentInviteDate: row.createdAt,
            assessmentStatus: row.assessment?.status,
            invitee: row.invitee.name,
            assessmentType: row.assessmentRoute.name,
            lastReminderSent: row.lastReminderSent,
            tags: row.tags
        }
    })
}


export const DataTableComp = () => {
    const [isActive, setActive] = useState(true)
    const [tableType, setTableType] = useState(TABLE_TYPE_ASSESSMENTS);
    const [data, setData] = useState([]);
    const [dataLabels, setDataLabels] = useState([]);
    const [activeAssesmentTagEditRowIndex, setActiveAssesmentTagEditRowIndex] = useState(-1)
    const [activeInviteTagEditRowIndex, setActiveInviteTagEditRowIndex] = useState(-1)


    const [dataInvites, setDataInvites] = useState([]);
    const [loadingAssessments, setLoadingAssessments] = useState(true);
    const [loadingInvites, setLoadingInvites] = useState(true);
    const [allData, setAllData] = useState([]);
    const [allDataLabels, setAllDataLabels] = useState([]);
    const [allDataInvites, setAllDataInvites] = useState([]);
    const [assessmentRoutes, setAssessmentRoutes] = useState<[AssessmentRoute] | []>([]);
    const [reminderContent, setReminderContent] = useState([]);
    const [sendInvite, setSendInvite] = useState(false)
    const [sendReminder, setSendReminder] = useState(false)
    const [shareAssessment, setShareAssessment] = useState(false)
    const [shareContent, setShareContent] = useState([]);
    const [tagSuggestions, setTagSuggestions] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const location = useLocation();

    useEffect(() => {
        if(location.search) {
            const queryValues = parseQuery(location.search);
            // @ts-ignore
            if(queryValues?.tab !== undefined && queryValues?.tab === 'invites') {
                setTableType(TABLE_TYPE_INVITES)
            }
        }
    }, []);


    useQuery(ASSESSMENTS, {
        onCompleted: (someData) => {
            setActive(isActive => !isActive)
            setLoadingAssessments(false)
            setData(mapData(someData))
            setDataLabels(mapDataLabels(someData))
            setAllData(mapData(someData))
            setAllDataLabels(mapDataLabels(someData))
        //     setLoading(true);
        //     // @ts-ignore
        //     setData(data)
        //     setTotalRows(data.length)
        //     setLoading(false)
        },
        fetchPolicy: "no-cache"
    });


    useQuery(ASSESSMENTS_INVITES, {
        onCompleted: (someData) => {

            setLoadingInvites(false)
            setDataInvites(mapDataInvites(someData))
            setAllDataInvites(mapDataInvites(someData))
            //     setLoading(true);
            //     // @ts-ignore
            //     setData(data)
            //     setTotalRows(data.length)
            //     setLoading(false)
        },
        fetchPolicy: "no-cache"
    });


    useQuery(TAG_SUGGESTIONS, {
        onCompleted: (someData) => {
            setTagSuggestions(someData.tagSuggestions)
        },
        fetchPolicy: "no-cache"
    });


    useQuery(ASSESSMENTS_ROUTES, {
        onCompleted: (someData) => {
            setAssessmentRoutes(someData.myAssessmentRoutes)
        },
        fetchPolicy: "no-cache"
    });

    // const fetchUsers = async (page: number) => {
    //     setLoading(true);
    //
    //     // @ts-ignore
    //     setData(data);
    //     // @ts-ignore
    //     setTotalRows(total);
    //     setLoading(false);
    // };


    const searchAction = (search: string) => {
        search = search.toLowerCase()

        if(tableType === TABLE_TYPE_INVITES) {
            const result = allDataInvites.filter((row: AssessmentInviteTableRow) => {
                // @ts-ignore
                return (
                row.companyParentName?.toLowerCase().includes(search)
                || row.companyName?.toLowerCase().includes(search)
                || row.founder?.toLowerCase().includes(search)
                || row.emailAddressFounder?.toLowerCase().includes(search)
                || row.assessmentInviteDate?.toLowerCase().includes(search)
                || row.assessmentStatus?.toLowerCase().includes(search)
                || row.invitee?.toLowerCase().includes(search)
                || row.assessmentType?.toLowerCase().includes(search)
                || row.tags?.map(tag => tag.name.toLowerCase()).join('').includes(search)
                )
            })

            setDataInvites(result)
        } else {
            const result = allData.filter((row: AssessmentTableRow) => {
                // @ts-ignore
                return (
                    row.companyName?.toLowerCase().includes(search)
                    || row.companyParentName?.toLowerCase().includes(search)
                    || row.contactPerson?.toLowerCase().includes(search)
                    // || row.status.toLowerCase().includes(search)
                    || row.assessmentDate.toLowerCase().includes(search)
                    || row.founder?.toLowerCase().includes(search)
                    || row.foundingDate?.toLowerCase().includes(search)
                    || row.sector?.toLowerCase().includes(search)
                    || row.tags?.map(tag => tag.name.toLowerCase()).join('').includes(search)
                )
            })

            setData(result)
            setDataLabels(result)
        }
    }


    return (
        <div className={styles.wrapper}>
            <Loader active={isActive}>
            <RequestAssessment
                routes={assessmentRoutes}
                isOpen={sendInvite}
                onOpenChange={(isOpen: boolean) => {
                    setSendInvite(isOpen)
                }}
            />
            <ShareAssessment
                isOpen={shareAssessment}
                onOpenChange={(isOpen: boolean) => {
                    setShareAssessment(isOpen)
                }}
                // @ts-ignore
                shareContent={shareContent}
            />
            <RemindAssesssment
                isOpen={sendReminder}
                onOpenChange={(isOpen: boolean) => {
                    setSendReminder(isOpen)
                }}
                // @ts-ignore
                reminderContent={reminderContent}
            />

            <Formik
                initialValues={initialFormValues}
                onSubmit={(
                    values: {
                        search: string
                    },
                ) => {
                    const { search } = values;
                    searchAction(search);
                }}
            >
                {({ values, handleChange, handleSubmit }) => (
                        <form className={styles.formContainer} onSubmit={handleSubmit}>
                            <div className={styles.searchContainer}>
                                <Field
                                    name='search'
                                    as={Input}
                                    type='text'
                                    placeholder='Filter on...'
                                    onChange={handleChange}
                                    value={values.search}
                                    // autoFocus
                                />
                                <span title="Reset" onClick={() => {
                                    values.search = '';
                                }} className={styles.clearSearch}>X</span>
                                <button type='submit'>
                                    <img
                                        src='/assets/search.svg'
                                        width='20'
                                        height='20'
                                        alt='search'
                                    />
                                </button>
                            </div>
                            <div className={styles.filterButtons}>
                                <Button
                                    type="button"
                                    className={ tableType === TABLE_TYPE_ASSESSMENTS ? 'dark' : 'primaryBordered'}
                                    title={ tableType === TABLE_TYPE_ASSESSMENTS ? '' : 'All scans'}
                                    onClick={() => {
                                        values.search = '';
                                        searchAction('');
                                        setTableType(TABLE_TYPE_ASSESSMENTS)
                                }}>
                                    All scans
                                </Button>
                                <Button
                                    type="button"
                                    className={ tableType === TABLE_TYPE_INVITES ? 'dark' : 'primaryBordered'}
                                    title={ tableType === TABLE_TYPE_INVITES ? '' : 'Invites'}
                                    onClick={() => {
                                        values.search = '';
                                        searchAction('');
                                        setTableType(TABLE_TYPE_INVITES)
                                }}>
                                    Invited
                                </Button>
                                {/*TODO add labelTable button*/}
                                <Button
                                    type="button"
                                    className={ tableType === TABLE_TYPE_LABELS ? 'dark' : 'primaryBordered'}
                                    title={ tableType === TABLE_TYPE_LABELS ? '' : 'Add labels'}
                                    onClick={() => {
                                        values.search = '';
                                        searchAction('');
                                        setTableType(TABLE_TYPE_LABELS)
                                    }}>
                                    Labels
                                </Button>
                            </div>
                        </form>
                    )}
            </Formik>
            <span className={styles.recordsSpan}>No. records: {tableType === TABLE_TYPE_INVITES ? dataInvites.length : data.length}</span>
            <br/>
                <div className={styles.main}>
                    {tableType === TABLE_TYPE_ASSESSMENTS &&
                        <DataTable
                            // @ts-ignore
                            customStyles={customStyles}
                            // title="Bibliotheek"
                            // @ts-ignore
                            columns={columns(
                                (row: any) => {
                                    setShareAssessment(true)
                                    setShareContent(row)
                                },
                                activeAssesmentTagEditRowIndex,
                                (index: number) => {
                                    setActiveAssesmentTagEditRowIndex(index)
                                    setActiveInviteTagEditRowIndex(-1)
                                },
                                tagSuggestions
                            )}
                            onRowClicked={(row, e: React.MouseEvent) => {
                                setActiveAssesmentTagEditRowIndex(-1)
                            }}
                            pagination
                            data={data}
                            defaultSortFieldId="assessmentDate"
                            defaultSortAsc={false}
                            highlightOnHover
                            progressPending={loadingAssessments}
                            noDataComponent={<div style={{padding: "100px"}}>No records found</div>}
                            // rowKey="id"
                            fixedHeader={true}
                            fixedHeaderScrollHeight={"800px"}
                        />
                    }
                    { tableType === TABLE_TYPE_LABELS &&
                        //TODO make a seperate 'labelTable' that is designed for the purpose of adding labels

                        <DataTable
                            // @ts-ignore
                            customStyles={customStyles}

                            // title="Bibliotheek"
                            // @ts-ignore
                            columns={columnsLabels(
                                (row: any) => {
                                    setShareAssessment(true)
                                    setShareContent(row)
                                },
                                activeAssesmentTagEditRowIndex,
                                (index: number) => {
                                    setActiveAssesmentTagEditRowIndex(index)
                                    setActiveInviteTagEditRowIndex(-1)
                                },
                                tagSuggestions
                            )}
                            onRowClicked={(row, e: React.MouseEvent) => {
                                setActiveAssesmentTagEditRowIndex(-1)
                            }}
                            pagination
                            data={dataLabels}
                            defaultSortFieldId={"labelTable"}
                            // defaultSortFieldId="companyName"
                            defaultSortAsc={false}
                            highlightOnHover
                            progressPending={loadingAssessments}
                            noDataComponent={<div style={{padding:"100px"}}>No records found</div>}
                            // rowKey="id"
                            fixedHeader={true}
                            fixedHeaderScrollHeight={"800px"}
                        />
                    }
                    { tableType === TABLE_TYPE_INVITES &&
                        <DataTable
                            // @ts-ignore
                            customStyles={customStyles}
                            // title="Bibliotheek"
                            // @ts-ignore
                            columns={columnsInvites(
                                (row: any) => {
                                    setSendReminder(true)
                                    setReminderContent(row)

                                    console.log('Clicked on button with id ' + row.id)
                                },
                                activeInviteTagEditRowIndex,
                                (index: number) => {
                                    setActiveAssesmentTagEditRowIndex(-1)
                                    setActiveInviteTagEditRowIndex(index)
                                },
                                tagSuggestions
                            )}
                            onRowClicked={(row, e: React.MouseEvent) => {
                                setActiveInviteTagEditRowIndex(-1)
                            }}
                            pagination
                            data={dataInvites}
                            defaultSortFieldId="assessmentInviteDate"
                            defaultSortAsc={false}
                            highlightOnHover
                            progressPending={loadingInvites}
                            noDataComponent={<div style={{padding:"40px"}}>No records found</div>}
                            // rowKey="id"
                            fixedHeader={true}
                            fixedHeaderScrollHeight={"800px"}
                        />
                    }
                </div>
            </Loader>
        </div>
    )
};

